export const initialState = {
  shopingCart: [],
  totatQuntity: 0,
};
